import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { createFastlaneClient } from '@packages/services';

const FASTLANE_URL = getPublicRuntimeConfig('FASTLANE_URL');
const TARGET_ENV = getPublicRuntimeConfig('TARGET_ENV');

export const useFastlane = () => {
  const fastlaneClient = createFastlaneClient(FASTLANE_URL, TARGET_ENV, console.warn);

  return fastlaneClient;
};
